export default [
    {
        "City" : "Bangalore"
    },
    {
        "City" : "gwalior"
    },
    {
        "City" : "Indore"
    },
    {
        "City" : "Gurugram"
    },
    {
        "City" : "New Delhi"
    },
    {
        "City" : "Chandigarh"
    },
    {
        "City" : "Goa"
    },
    {
        "City" : "Telangana"
    },
    {
        "City" : "Bhubaneswar"
    },
    {
        "City" : "Kolkata"
    },
    {
        "City" : "Jammu and Kashmir"
    },
    {
        "City" : "Ajmer"
    },
    {
        "City" : "Banda"
    },
    {
        "City" : "Betul"
    },{
        "City" : "Jaipur"
    }
]